import {CheckoutController} from '@wc-stripe/controllers';
import {getPage, getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {UPMCheckoutSessionGateway} from '@wc-stripe/gateways';

/**
 * Adaptive Pricing bootstrap for the Universal Payment Method (Phase 1).
 *
 * Enqueued as `wc-stripe-upm-checkout-session-init` in place of `wc-stripe-upm-checkout` when
 * Adaptive Pricing is enabled (see src/AdaptivePricing/UPMCheckoutSessionController.php). A plain
 * CheckoutController is used - there's only one gateway, so none of the Phase 2
 * CheckoutSessionController arbitration applies.
 *
 * @since 4.1.0
 */
const settings = getSetting('stripe_upm_data');
const session = getSetting('checkoutSession');

const context = new Context(getPage());

const gateway = new UPMCheckoutSessionGateway({
    id: 'stripe_upm',
    settings,
    session,
    context
});

const controller = new CheckoutController({
    context,
    gateway,
    selector: '#wc-stripe-upm-element'
});

controller.initialize();